const estados = ['AC', 'AL', 'AM', 'AP', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RO', 'RS', 'RR', 'SC', 'SE', 'SP', 'TO'];

function estados_plugin() { }

estados_plugin.prototype.install = function (app) {
    app.config.globalProperties.$estados = estados;
}

export function EstadosPlugin() {
    return new estados_plugin();
}